import { Jugador, JugadorJSON } from '../Jugador/Jugador';
import { JugadorXEquipo } from '../JugadorXEquipo/JugadorXEquipo';
import { TorneoListaBuenaFeJugador } from '../TorneoListaBuenaFeJugador/TorneoListaBuenaFeJugador';

export interface PlanillaPartidoJugadorJSON {
  ppj_id: string | null;
  ppj_ppid: number;
  ppj_eqid: number;
  ppj_jugid: number;
  ppj_dorsal: number;
  ppj_es_capitan: boolean;

  jugador: JugadorJSON;
  __delete: boolean;
}

export class PlanillaPartidoJugador {
  private pendingChanges: boolean;

  protected constructor(
    private id: string | null,
    private ppid: number,
    private eqid: number,
    private jugid: number,
    private dorsal: number,
    private esCapitan: boolean,

    private jugador: Jugador,
    private __delete: boolean
  ) {
    this.pendingChanges = false;
  }

  static createFrom(
    id: string | null,
    ppid: number,
    eqid: number,
    jugid: number,
    dorsal: number,
    esCapitan: boolean,

    jugador: Jugador,
    __delete: boolean
  ) {
    return new this(id, ppid, eqid, jugid, dorsal, esCapitan, jugador, __delete);
  }

  static createFromBuenaFe(
    planillaId: number,
    jugBuenaFe: TorneoListaBuenaFeJugador,
    useDorsalDefault: boolean = true
  ) {
    return PlanillaPartidoJugador.createFrom(
      '',
      +planillaId,
      +jugBuenaFe.getTorneoListaBuenaFe()!.getEqid(),
      +jugBuenaFe.getJugid(),
      useDorsalDefault ? jugBuenaFe.getDorsal() : 0,
      false,

      jugBuenaFe.getJugador()!,
      false
    );
  }

  static createFromJugadorXEquipo(planillaId: number, jxe: JugadorXEquipo) {
    return PlanillaPartidoJugador.createFrom(
      '',
      planillaId,
      +jxe.getEqid(),
      jxe.getJugid(),
      0,
      false,

      jxe.getJugador(),
      false
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartidoJugador) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    }
    return false;
  }

  static fromJSON(entity: PlanillaPartidoJugadorJSON) {
    return PlanillaPartidoJugador.createFrom(
      entity.ppj_id,
      entity.ppj_ppid,
      entity.ppj_eqid,
      entity.ppj_jugid,
      entity.ppj_dorsal,
      entity.ppj_es_capitan,

      Jugador.fromJSON(entity.jugador),
      entity.__delete
    );
  }

  toJSON(): PlanillaPartidoJugadorJSON {
    return {
      ppj_id: this.getId(),
      ppj_ppid: this.getPpid(),
      ppj_eqid: this.getEqid(),
      ppj_jugid: this.getJugid(),
      ppj_dorsal: this.getDorsal(),
      ppj_es_capitan: this.isCapitan(),

      jugador: this.getJugador().toJSON(),
      __delete: this.__delete,
    };
  }

  dorsalEs(unaDorsal: string | number): boolean {
    return +this.getDorsal() === +unaDorsal;
  }

  setHasPengingChanges(v: boolean) {
    this.pendingChanges = v;
  }

  hasPendingChanges() {
    return this.pendingChanges;
  }

  isActive(): boolean {
    return !this.__delete;
  }

  getId(): string | null {
    return this.id;
  }

  getPpid(): number {
    return this.ppid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getJugid(): number {
    return this.jugid;
  }

  getDorsal(): number {
    return this.dorsal;
  }
  isCapitan(): boolean {
    return this.esCapitan;
  }

  setIsCapitan(v: boolean) {
    this.esCapitan = v;
  }

  getJugador(): Jugador {
    return this.jugador;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  set__delete(value: boolean): void {
    this.__delete = value;
  }

  setPpid(value: number): void {
    this.ppid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setJugid(value: number): void {
    this.jugid = value;
  }

  setDorsal(value: number): void {
    this.dorsal = value;
  }

  setDeleted(d: boolean) {
    this.__delete = d;
  }
}
